const sponsors = {
  //BUTTON
  button: {
    title: "message.sponsors.button",
    link: "message.donate.sponsorship.link.href",
  },

  //Title
  title: [
    {
      src: "https://www.danatm4.com/fr/",
      imageSrc: "/static/sponsors/Dana-TM4.png",
    },
  ],

  //DIAMOND
  diamond: [
    {
      src: "https://www.aeets.com/",
      imageSrc: "/static/sponsors/AEETS.png",
      whiteVersion: "/static/sponsors/aeets-white.png",
    },
    {
      src: "http://www.avior.ca/index_fr.html",
      imageSrc: "/static/sponsors/Avior.png",
      whiteVersion: "/static/sponsors/Avior-white.png",
    },
    {
      src: "https://www.ford.ca/",
      imageSrc: "/static/sponsors/Ford-Logo-1965-present.png",
      whiteVersion: "/static/sponsors/Ford-white.png",
    },
    {
      src: "https://www.renishaw.fr/fr/renishaw-amelioration-du-rendement-en-fabrication-et-en-soins-de-sante--1030",
      imageSrc: "/static/sponsors/Renishaw.png",
      whiteVersion: "/static/sponsors/Renishaw-white.png",
    },
    /*{
      src: "http://supalloy.com/fr/",
      imageSrc: "/static/sponsors/Technologie+Superieure+D%27alliage.png",
      whiteVersion:
        "/static/sponsors/Technologie+Superieure+D_alliage-white.png",
    },*/
  ],

  //GOLD
  gold: [
    {
      src: "https://altair.com/",
      imageSrc: "/static/sponsors/Altair.png",
    },
    {
      src: "https://www.avlracetech.com/",
      imageSrc: "/static/sponsors/avlRacetech.png",
    },
    {
      src: "https://www.awl-e.com/",
      imageSrc: "/static/sponsors/AWL_Purp.png",
    },
    {
      src: "https://www.bombardier.com/",
      imageSrc: "/static/sponsors/Bombardier.png",
    },
    {
      src: "https://www.bosch-motorsport.com/",
      imageSrc: "/static/sponsors/Bosch.png",
    },
    {
      src: "https://www.brp.com/",
      imageSrc: "/static/sponsors/BRP.png",
    },
    {
      src: "https://www.creaform3d.com/fr",
      imageSrc: "/static/sponsors/faro_creaform_rgb_horiz.png",
    },
    {
      src: "https://fischer-elektromotoren.de/en/",
      imageSrc: "/static/sponsors/Fischer.png",
    },
    {
      src: "https://www.fluke.com/fr-ca",
      imageSrc: "/static/sponsors/Fluke.png",
    },
    /*{
      src: "https://www.harting.com/en-US",
      imageSrc: "/static/sponsors/Harting.png",
    },*/
    {
      src: "https://www.hitachienergy.com/ca/en",
      imageSrc: "/static/sponsors/Hitachi_Global_Logo_Red1_PANTONE_original.png",
    },
    /*{
      src: "https://hitechseals.com/",
      imageSrc: "/static/sponsors/HitecSeals.png",
    },*/
    /*{
      src: "https://www.hutchinson.com/fr/aerospace/",
      imageSrc: "/static/sponsors/Hutchinson.png",
    },*/
    {
      src: "https://www.kisssoft.ch/english/home/index.php",
      imageSrc: "/static/sponsors/kisssoft_logo_grey_rgb.png",
      whiteVersion: "/static/sponsors/KISSsoft-white.png",
    },
    /*{
      src: "https://www.brp.com/",
      imageSrc: "/static/sponsors/Megatech.png",
    },*/
    {
      src: "https://www.ntop.com/",
      imageSrc: "/static/sponsors/Ntop.png",
    },
    {
      src: "https://mdx.plm.automation.siemens.com/star-ccm-plus",
      imageSrc: "/static/sponsors/Siemens.png",
    },
    /*{
      src: "https://www.usinagetrudel.ca/",
      imageSrc: "/static/sponsors/usinageTrudel.png",
    },*/
    {
      src: "https://www.soucy-track.com",
      imageSrc: "/static/sponsors/Soucy.png",
    },
    {
      src: "https://cmqtr.qc.ca/",
      imageSrc: "/static/sponsors/CMQ.png",
    },
  ],

  //SILVER
  silver: [
    {
      src: "https://www.3mcanada.ca/3M/fr_CA/company-ca/",
      imageSrc: "/static/sponsors/3M.png",
    },
    {
      src: "https://airtechintl.com/",
      imageSrc: "/static/sponsors/Airtech.png",
    },
    {
      src: "https://blaxes.com/",
      imageSrc: "/static/sponsors/Blaxes.png",
    },
    {
      src: "https://www.carrefourangrignon.com/",
      imageSrc: "/static/sponsors/Carrefour angrignon_logo.png",
    },
    {
      src: "https://comptoiragricole.com/",
      imageSrc: "/static/sponsors/casa-noir-fr.png",
    },
    {
      src: "https://www.cdcq.qc.ca/",
      imageSrc: "/static/sponsors/cdcq-logocouleur_horizontal.png",
    },
    {
      src: "https://www.placeportobello.com/",
      imageSrc: "/static/sponsors/cropped-Portobello-Wix-Directory-14.png",
    },
    {
      src: "https://www.drillmex.com/",
      imageSrc: "/static/sponsors/Drillmex.png",
    },
    {
      src: "https://www.facebook.com/DrivenLogicCnc/",
      imageSrc: "/static/sponsors/Driven-Logic.png",
    },
    /*{
      src: "https://www.fondationbombardier.ca/",
      imageSrc: "/static/sponsors/ArmandBombardier.png",
    },*/
    {
      src: "https://www.rad-acme.com/",
      imageSrc: "/static/sponsors/logoACME_GIMP.jpg",
    },
    {
      src: "https://www.groupenovatech.com/fr_canada_quebec/",
      imageSrc: "/static/sponsors/Logo-Novatech-RGB.png",
    },
    {
      src: "https://www.melasta.com/",
      imageSrc: "/static/sponsors/melasta Logo.png",
    },
    {
      src: "https://rapidharness.com/",
      imageSrc: "/static/sponsors/Rapid+Harness.png",
    },
    {
      src: "https://sklaluminium.com/",
      imageSrc: "/static/sponsors/SKL_aluminiumv2.png",
    },
    {
      src: "https://vanguardsteel.com/",
      imageSrc: "/static/sponsors/Vanguard+Steel.png",
    },
    {
      src: "https://www.zintilon.com/",
      imageSrc: "/static/sponsors/zintillon.png",
    },
  ],

  //BRONZE 
  bronze: [
    {
      src: "http://www.amcanjumax.com/",
      imageSrc: "/static/sponsors/amcan+Jumax.png",
    },
    {
      src: "https://anodisationexpert.com/",
      imageSrc: "/static/sponsors/anodisation expert.png",
    },
    {
      src: "https://avitecnet.com/fr/",
      imageSrc: "/static/sponsors/avitec.png",
    },
    {
      src: "http://www.bmrswired.com/",
      imageSrc: "/static/sponsors/BMRS+Wired.png",
    },
    {
      src: "https://www.ckworldwide.com/",
      imageSrc: "/static/sponsors/Ck.png"
    },
    {
      src: "https://www.cta-brp-udes.com/",
      imageSrc: "/static/sponsors/CTA.png"
    },
    {
      src: "https://hawkeyeind.com/",
      imageSrc: "/static/sponsors/Hawkeye-Logo-2.png"
    },
    {
      src: "https://www.ushgt.com/",
      imageSrc: "/static/sponsors/HGT.png"
    },
    {
      src: "https://www.sealsonline.com/fr/rbmtl",
      imageSrc: "/static/sponsors/les-joints-étanches-rb-inc-logo-16038007065.png"
    },
    {
      src: "https://www.ivisolutions.ca/",
      imageSrc: "/static/sponsors/logoIvi.png"
    },
    {
      src: "https://www.multimatic.com/",
      imageSrc: "/static/sponsors/Multimatic.png",
    },
    {
      src: "https://www.niteklaser.com/",
      imageSrc: "/static/sponsors/Nitek Laser.png",
    },
    {
      src: "https://www.pciauto.com/",
      imageSrc: "/static/sponsors/pci couleur.png",
    },
    {
      src: "https://www.prowireusa.com/",
      imageSrc: "/static/sponsors/Prowiresa_Website-Logo.png",
    },
    {
      src: "https://www.rls.si/",
      imageSrc: "/static/sponsors/rls-logo-r.png",
    },
    {
      src: "https://www.shkarting.com/",
      imageSrc: "/static/sponsors/SH-Karting-new.png",
    },
    {
      src: "https://www.skf.com/ca/en",
      imageSrc: "/static/sponsors/skf.png",
    },
    {
      src: "https://www.vulcain.com/",
      imageSrc: "/static/sponsors/Vulcain.png",
    },
  ],

  //CLASSIC
  classic: [
    {
      src: "https://www.analog.com/en/index.html",
      imageSrc: "/static/sponsors/Analog-Devices.png",
    },
    {
      src: "https://www.bolle-safety.com/ca/",
      imageSrc: "/static/sponsors/Bolle.png",
    },
    {
      src: "https://www.calogysolutions.com/",
      imageSrc: "/static/sponsors/Calogy_Logo_rgb.jpg",
    },
    {
      src: "https://www.isabellenhuette.com/",
      imageSrc: "/static/sponsors/isabellenhutte_logo_2020.jpg",
    },
    {
      src: "https://itwperformancepolymers.com/",
      imageSrc: "/static/sponsors/ITW.png",
    },
    {
      src: "https://www.keyshot.com/",
      imageSrc: "/static/sponsors/keyshot-corp-logo-drk-3d.png",
    },
    {
      src: "https://metalcn.ca/",
      imageSrc: "/static/sponsors/metalCN.png",
    },
    {
      src: "https://nestandcut.com/fr/",
      imageSrc: "/static/sponsors/Logo-Nest&Cut-color.png",
    },
    {
      src: "https://www.mmus.com/",
      imageSrc: "/static/sponsors/MMUS.png",
    },
    {
      src: "https://www.permabond.com/",
      imageSrc: "/static/sponsors/permabond-logo-BLUE-1.png",
    },
    {
      src: "https://perryautolaval.com/",
      imageSrc: "/static/sponsors/Perry auto.png",
    },
    {
      src: "https://www.ptselectrique.com/",
      imageSrc: "/static/sponsors/pts electrique.png",
    },
    {
      src: "https://www.samtec.com/",
      imageSrc: "/static/sponsors/samtec.png",
    },
  ],
};

export default sponsors;
